module.exports = __webpack_public_path__ + "static/media/user.0b866d6a.svg";